// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.fullNews-container {
  font-family: 'Arial', 'Helvetica', 'Sans-serif';
  container-type: inline-size;
  cursor: auto;
  box-sizing: border-box;
  min-width: 328px;
  height: 100%;
  max-height: 100dvh;
  display: flex;
  flex-direction: column;
}

.fullNews {
  display: flex;
  flex-direction: column;
  flex: 1;
  min-height: 0;
}

.fullNews-menu {
  display: flex;
  align-items: center;
  height: 40px;
  box-sizing: content-box;
  padding: 0 16px 16px 16px;
}

.fullNews-menu-region {
  flex: 1;
}

@container (min-width: 768px) {
  .fullNews-menu-region {
    max-width: 160px;
  }
}

.fullNews-menu-sector {
  flex: 1;
}

@container (min-width: 768px) {
  .fullNews-menu-sector {
    max-width: 180px;
  }
}

.fullNews-menu-search {
  display: inline-flex;
  align-items: center;
  box-sizing: border-box;
  height: 100%;
  padding: 5px 8px;
  gap: 6px;
  flex: 1;
  border: 1px solid var(--color-brand);
  border-radius: 4px;
  position: relative;
}

.fullNews-menu-search .input-box {
  position: static;
}

.fullNews-menu-search-input-wrapper {
  display: flex;
  box-sizing: border-box;
  align-items: center;
  flex: 1;
  height: 22px;
}

.fullNews-menu-search-clear {
  display: flex;
  align-items: center;
  justify-content: center;
  box-sizing: border-box;
  padding: 0px;
  border: none;
  background-color: transparent;
  cursor: pointer;
  height: 100%;

  svg {
    width: 16px;
    height: 16px;

    path {
      fill: var(--accent-secondary);
    }
  }
}

.fullNews-menu-refresh {
  display: inline-flex;
  align-items: center;
  box-sizing: border-box;
  height: 100%;
  padding: 3px 9px;
  border: 1px solid var(--color-brand);
  border-radius: 4px;
  margin-left: 4px;
  cursor: pointer;
  &:hover {
    background-color: var(--color-brand-hover2);
  }
}

.fullNews-menu-refresh-icon {
  path {
    fill: var(--color-brand);
  }
}

.fullNews-content-container {
  box-sizing: border-box;

  display: flex;
  flex-direction: column;
  flex: 1;
  width: 100%;
  min-height: 0;
}

.left-content {
  display: flex;
  flex-direction: column;
  min-height: 0;
  width: 100%;
  border: none;
}

.fullNews-content {
  display: flex;
  flex: 1;
  min-height: 0;
  width: 100%;
}

/* Loading/empty state: menu only, the state container takes the rest */
.fullNews-content:has(~ .fullNews-state-container) {
  flex: none;
}

.fullNews-content-list-container {
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  flex: 1;
  min-height: 0;

  width: 100%;
}

@container (min-width: 768px) {
  .fullNews-content-list-container {
    box-sizing: border-box;
    width: 100%;

    padding-right: 16px;
  }
  .left-content {
    width: 50%;
    border-right: 1px solid var(--border-secondary);
  }
  .left-content.left-content--no-border {
    border-right: none;
  }
  .fullNews-content-container {
    margin-top: 24px;
  }
}

.fullNews-content-list {
  box-sizing: border-box;
  width: 100%;
  flex: 1;
  min-height: 0;
  background-color: var(--surface-primary);
  overflow-y: hidden;
}

.fullNews-content-list .news-headline {
  &:nth-child(2n) {
    background-color: var(--row-dark);
  }
}

.fullNews-content-story {
  display: none;
  box-sizing: border-box;
  width: 50%;
  min-height: 0;
  padding-left: 16px;
}

.fullNews-content-story .story-container {
  padding: 0px;
}

@container (min-width: 768px) {
  .fullNews-content-story {
    display: block;
  }
}

.fullNews .pagination {
  margin-top: auto;
  flex-shrink: 0;
}

.fullNews .modal-story {
  height: 100%;
}

.fullNews-content-loading-spinner {
  font-size: 16px;
}

.fullNews-content-loading-spinner {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  position: relative;
}

.fullNews-content-empty-text {
  margin-top: 20px;
  font-family: 'Arial', 'Helvetica', 'Sans-serif';
  font-weight: 700;
  font-style: Bold;
  font-size: 20px;
  line-height: 28px;
  letter-spacing: 0px;
  text-align: center;
  vertical-align: middle;
  color: var(--text-primary);
}

.fullNews-state-container {
  width: 100%;
  flex: 1;
  min-height: 0;
}

.mobile-story-fullscreen {
  display: flex;
  flex-direction: column;
  width: 100%;
  flex: 1;
  min-height: 0;
  overflow: hidden;
  padding-top: 16px;
}

/* Fill with flex, not height: 100%: .fullNews-container is only capped by
   max-height (no definite height), so % heights resolve to auto and the
   story grows past the viewport instead of scrolling */
.mobile-story-fullscreen .story-container {
  display: flex;
  flex-direction: column;
  flex: 1;
  min-height: 0;
  position: relative;
}

.mobile-story-fullscreen .story-content-container {
  flex: 1;
  min-height: 0;
  height: auto;
  overflow-y: auto;
}
`, "",{"version":3,"sources":["webpack://./src/Widgets/FullNewsWidget/FullNewsWidget.css"],"names":[],"mappings":"AAAA;EACE,+CAA+C;EAC/C,2BAA2B;EAC3B,YAAY;EACZ,sBAAsB;EACtB,gBAAgB;EAChB,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,OAAO;EACP,aAAa;AACf;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,uBAAuB;EACvB,yBAAyB;AAC3B;;AAEA;EACE,OAAO;AACT;;AAEA;EACE;IACE,gBAAgB;EAClB;AACF;;AAEA;EACE,OAAO;AACT;;AAEA;EACE;IACE,gBAAgB;EAClB;AACF;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,sBAAsB;EACtB,YAAY;EACZ,gBAAgB;EAChB,QAAQ;EACR,OAAO;EACP,oCAAoC;EACpC,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,OAAO;EACP,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,sBAAsB;EACtB,YAAY;EACZ,YAAY;EACZ,6BAA6B;EAC7B,eAAe;EACf,YAAY;;EAEZ;IACE,WAAW;IACX,YAAY;;IAEZ;MACE,6BAA6B;IAC/B;EACF;AACF;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,sBAAsB;EACtB,YAAY;EACZ,gBAAgB;EAChB,oCAAoC;EACpC,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf;IACE,2CAA2C;EAC7C;AACF;;AAEA;EACE;IACE,wBAAwB;EAC1B;AACF;;AAEA;EACE,sBAAsB;;EAEtB,aAAa;EACb,sBAAsB;EACtB,OAAO;EACP,WAAW;EACX,aAAa;AACf;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,aAAa;EACb,WAAW;EACX,YAAY;AACd;;AAEA;EACE,aAAa;EACb,OAAO;EACP,aAAa;EACb,WAAW;AACb;;AAEA,uEAAuE;AACvE;EACE,UAAU;AACZ;;AAEA;EACE,sBAAsB;EACtB,aAAa;EACb,sBAAsB;EACtB,OAAO;EACP,aAAa;;EAEb,WAAW;AACb;;AAEA;EACE;IACE,sBAAsB;IACtB,WAAW;;IAEX,mBAAmB;EACrB;EACA;IACE,UAAU;IACV,+CAA+C;EACjD;EACA;IACE,kBAAkB;EACpB;EACA;IACE,gBAAgB;EAClB;AACF;;AAEA;EACE,sBAAsB;EACtB,WAAW;EACX,OAAO;EACP,aAAa;EACb,wCAAwC;EACxC,kBAAkB;AACpB;;AAEA;EACE;IACE,iCAAiC;EACnC;AACF;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,UAAU;EACV,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE;IACE,cAAc;EAChB;AACF;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,+CAA+C;EAC/C,gBAAgB;EAChB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;EAClB,sBAAsB;EACtB,0BAA0B;AAC5B;;AAEA;EACE,WAAW;EACX,OAAO;EACP,aAAa;AACf;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,OAAO;EACP,aAAa;EACb,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;;uDAEuD;AACvD;EACE,aAAa;EACb,sBAAsB;EACtB,OAAO;EACP,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,OAAO;EACP,aAAa;EACb,YAAY;EACZ,gBAAgB;AAClB","sourcesContent":[".fullNews-container {\n  font-family: 'Arial', 'Helvetica', 'Sans-serif';\n  container-type: inline-size;\n  cursor: auto;\n  box-sizing: border-box;\n  min-width: 328px;\n  height: 100%;\n  max-height: 100dvh;\n  display: flex;\n  flex-direction: column;\n}\n\n.fullNews {\n  display: flex;\n  flex-direction: column;\n  flex: 1;\n  min-height: 0;\n}\n\n.fullNews-menu {\n  display: flex;\n  align-items: center;\n  height: 40px;\n  box-sizing: content-box;\n  padding: 0 16px 16px 16px;\n}\n\n.fullNews-menu-region {\n  flex: 1;\n}\n\n@container (min-width: 768px) {\n  .fullNews-menu-region {\n    max-width: 160px;\n  }\n}\n\n.fullNews-menu-sector {\n  flex: 1;\n}\n\n@container (min-width: 768px) {\n  .fullNews-menu-sector {\n    max-width: 180px;\n  }\n}\n\n.fullNews-menu-search {\n  display: inline-flex;\n  align-items: center;\n  box-sizing: border-box;\n  height: 100%;\n  padding: 5px 8px;\n  gap: 6px;\n  flex: 1;\n  border: 1px solid var(--color-brand);\n  border-radius: 4px;\n  position: relative;\n}\n\n.fullNews-menu-search .input-box {\n  position: static;\n}\n\n.fullNews-menu-search-input-wrapper {\n  display: flex;\n  box-sizing: border-box;\n  align-items: center;\n  flex: 1;\n  height: 22px;\n}\n\n.fullNews-menu-search-clear {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  box-sizing: border-box;\n  padding: 0px;\n  border: none;\n  background-color: transparent;\n  cursor: pointer;\n  height: 100%;\n\n  svg {\n    width: 16px;\n    height: 16px;\n\n    path {\n      fill: var(--accent-secondary);\n    }\n  }\n}\n\n.fullNews-menu-refresh {\n  display: inline-flex;\n  align-items: center;\n  box-sizing: border-box;\n  height: 100%;\n  padding: 3px 9px;\n  border: 1px solid var(--color-brand);\n  border-radius: 4px;\n  margin-left: 4px;\n  cursor: pointer;\n  &:hover {\n    background-color: var(--color-brand-hover2);\n  }\n}\n\n.fullNews-menu-refresh-icon {\n  path {\n    fill: var(--color-brand);\n  }\n}\n\n.fullNews-content-container {\n  box-sizing: border-box;\n\n  display: flex;\n  flex-direction: column;\n  flex: 1;\n  width: 100%;\n  min-height: 0;\n}\n\n.left-content {\n  display: flex;\n  flex-direction: column;\n  min-height: 0;\n  width: 100%;\n  border: none;\n}\n\n.fullNews-content {\n  display: flex;\n  flex: 1;\n  min-height: 0;\n  width: 100%;\n}\n\n/* Loading/empty state: menu only, the state container takes the rest */\n.fullNews-content:has(~ .fullNews-state-container) {\n  flex: none;\n}\n\n.fullNews-content-list-container {\n  box-sizing: border-box;\n  display: flex;\n  flex-direction: column;\n  flex: 1;\n  min-height: 0;\n\n  width: 100%;\n}\n\n@container (min-width: 768px) {\n  .fullNews-content-list-container {\n    box-sizing: border-box;\n    width: 100%;\n\n    padding-right: 16px;\n  }\n  .left-content {\n    width: 50%;\n    border-right: 1px solid var(--border-secondary);\n  }\n  .left-content.left-content--no-border {\n    border-right: none;\n  }\n  .fullNews-content-container {\n    margin-top: 24px;\n  }\n}\n\n.fullNews-content-list {\n  box-sizing: border-box;\n  width: 100%;\n  flex: 1;\n  min-height: 0;\n  background-color: var(--surface-primary);\n  overflow-y: hidden;\n}\n\n.fullNews-content-list .news-headline {\n  &:nth-child(2n) {\n    background-color: var(--row-dark);\n  }\n}\n\n.fullNews-content-story {\n  display: none;\n  box-sizing: border-box;\n  width: 50%;\n  min-height: 0;\n  padding-left: 16px;\n}\n\n.fullNews-content-story .story-container {\n  padding: 0px;\n}\n\n@container (min-width: 768px) {\n  .fullNews-content-story {\n    display: block;\n  }\n}\n\n.fullNews .pagination {\n  margin-top: auto;\n  flex-shrink: 0;\n}\n\n.fullNews .modal-story {\n  height: 100%;\n}\n\n.fullNews-content-loading-spinner {\n  font-size: 16px;\n}\n\n.fullNews-content-loading-spinner {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  position: relative;\n}\n\n.fullNews-content-empty-text {\n  margin-top: 20px;\n  font-family: 'Arial', 'Helvetica', 'Sans-serif';\n  font-weight: 700;\n  font-style: Bold;\n  font-size: 20px;\n  line-height: 28px;\n  letter-spacing: 0px;\n  text-align: center;\n  vertical-align: middle;\n  color: var(--text-primary);\n}\n\n.fullNews-state-container {\n  width: 100%;\n  flex: 1;\n  min-height: 0;\n}\n\n.mobile-story-fullscreen {\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n  flex: 1;\n  min-height: 0;\n  overflow: hidden;\n  padding-top: 16px;\n}\n\n/* Fill with flex, not height: 100%: .fullNews-container is only capped by\n   max-height (no definite height), so % heights resolve to auto and the\n   story grows past the viewport instead of scrolling */\n.mobile-story-fullscreen .story-container {\n  display: flex;\n  flex-direction: column;\n  flex: 1;\n  min-height: 0;\n  position: relative;\n}\n\n.mobile-story-fullscreen .story-content-container {\n  flex: 1;\n  min-height: 0;\n  height: auto;\n  overflow-y: auto;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
